<template>
    <div class="modal fade" tabindex="-1" ref="modalPlano" id="ModalPlano">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 modal-plano">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                        @click="fecharModal"
                        aria-label="Fechar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>
                <div class="modal-body modal-plano-body">
                    <div class="modal-plano-inner">
                        <div class="modal-plano-header">
                            <h3 class="title modal-plano-title m-0 d-flex align-items-center gap-2">
                                <i class="bi bi-clipboard2-plus"></i>
                                Registro de Plano de Ação
                            </h3>
                            <p class="modal-plano-subtitle">Organize os planos relacionados ao mapa, vinculando-os rapidamente aos riscos cadastrados.</p>
                        </div>
                        <hr class="modal-plano-divider" />

                        <div v-if="nenhumRiscoDisponivel" class="alert-plano" role="alert">
                            <div class="alert-plano-icon">
                                <i class="bi bi-info-circle-fill"></i>
                            </div>
                            <div>
                                <strong>Nenhum risco cadastrado.</strong>
                                <span>Cadastre pelo menos um risco para liberar o registro de planos de ação.</span>
                            </div>
                        </div>

                        <div v-else class="modal-plano-content">
                            <div class="glass-card">
                                <div class="row g-4">
                                    <div class="form-group col-12">
                                        <label for="titulo" class="form-label">Título</label>
                                        <input type="text" v-model="titulo" class="form-control" :class="{ 'border-danger': camposInvalidos.titulo }" id="titulo" placeholder="Digite o título do plano" />
                                    </div>
                                </div>
                                <div class="row g-4">
                                    <div class="form-group col-12">
                                        <label for="descricao" class="form-label">Descrição</label>
                                        <textarea v-model="descricao" class="form-control" :class="{ 'border-danger': camposInvalidos.descricao }" id="descricao" rows="3" placeholder="Descreva o plano de ação..."></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="glass-card">
                                <div class="form-group riscos-group" :class="{ 'tem-erro': camposInvalidos.riscos }">
                                    <label for="riscos" class="form-label">Vincular Riscos</label>
                                    <input type="text"
                                           class="form-control filtro-risco"
                                           v-model="filtroRisco"
                                           placeholder="Filtrar riscos..." />
                                    <div class="lista-riscos">
                                        <label class="lista-riscos-item"
                                               v-for="risco in riscosFiltrados"
                                               :key="risco.idRisco">
                                            <input class="form-check-input"
                                                   type="checkbox"
                                                   :value="risco.idRisco"
                                                   v-model="riscosSelecionados" />
                                            <span class="codigo">{{ risco.cdRisco }}</span>
                                            <span class="titulo">{{ risco.dsTitulo }}</span>
                                        </label>
                                        <div v-if="riscosFiltrados.length === 0" class="lista-riscos-vazia">
                                            Nenhum risco encontrado para o filtro informado.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button class="btn btn-primary btn-save" @click="salvarPlanoAcao">
                                Salvar plano de ação
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        props: {
            planoAcao: {
                type: Object,
                default: null
            },
            idMatriz: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                titulo: "",
                descricao: "",
                camposInvalidos: {
                    titulo: false,
                    descricao: false,
                    riscos: false
                },
                riscosSelecionados: [],
                registroRiscos: [],
                filtroRisco: ""
            }
        },

        watch: {
            planoAcao: {
                immediate: true,
                handler(novoPlano) {
                    if (novoPlano) {
                        this.titulo = novoPlano.dsTitulo || "";
                        this.descricao = novoPlano.dsPlanoAcao || "";
                        
                    } else {
                        this.titulo = "";
                        this.descricao = "";
                    }
                }
            }
        },

        mounted() {
            this.carregarRegistroRiscos(this.idMatriz).then(() => {
                if ( 
                    this.planoAcao &&
                    this.planoAcao.idPlanoAcao > 0 && 
                    this.registroRiscos.length > 0
                ) {
                    this.carregarRiscosVinculados(this.planoAcao.idPlanoAcao);
                }
            });
        },

        computed: {
            riscosFiltrados() {
                const termo = this.filtroRisco.toLowerCase();
                return this.registroRiscos.filter(r => {
                    const cd = (r.cdRisco ?? "").toString();
                    const titulo = (r.dsTitulo ?? "").toString();
                    return (cd + titulo).toLowerCase().includes(termo);
                });
            },
            nenhumRiscoDisponivel() {
                return this.registroRiscos.length === 0;
            }
        },

        methods: {
            carregarRegistroRiscos(idMatriz) {
                return axios.get(`${urlApi}/GerenciamentoRisco/Get`, {
                    params: { idMatriz: idMatriz }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.registroRiscos = (res.data.data?.rows || []).map(x => x.risco);
                        } else {
                            avisoErro("Erro ao buscar registro de riscos.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição dos riscos.");
                    });
            },

            salvarPlanoAcao() {
                this.camposInvalidos.titulo = !this.titulo?.trim();
                this.camposInvalidos.descricao = !this.descricao?.trim();

                const nenhumRiscoSelecionado = this.riscosSelecionados.length === 0;
                this.camposInvalidos.riscos = nenhumRiscoSelecionado;

                if (nenhumRiscoSelecionado) {
                    avisoErro("É necessário vincular pelo menos um risco ao plano de ação.");
                    return;
                }

                if (this.camposInvalidos.titulo || this.camposInvalidos.descricao) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return;
                }


                const payload = {
                    DadosPlano: { 
                        idPlanoAcao: this.planoAcao?.idPlanoAcao || 0,
                        idMatriz: this.idMatriz,
                        dsTitulo: this.titulo,
                        cdPlanoAcao: this.planoAcao?.cdPlanoAcao || 0,
                        dsPlanoAcao: this.descricao
                    },
                    Riscos: this.riscosSelecionados 
                };

                axios.post(`${urlApi}/GerenciamentoPlanoAcao/Post`, payload)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Plano de ação salvo com sucesso!");
                            this.$emit('salvoComSucesso');
                            this.fecharModal();
                        } else {
                            avisoErro(res.data.msg || "Erro ao salvar o plano de ação.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição de salvamento.");
                    });
            },

            carregarRiscosVinculados(idPlanoAcao) {
                axios.get(`${urlApi}/GerenciamentoPlanoAcao/GetRiscosPorPlano/${idPlanoAcao}`)
                    .then(res => {
                        if (res.data.success) {
                            this.riscosSelecionados = res.data.data || [];
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar riscos vinculados.");
                    });
            },

            fecharModal() {
                const modalEl = document.getElementById('ModalPlano');
                if (modalEl) {
                    const modal = window.bootstrap.Modal.getInstance(modalEl);
                    modal.hide();
                }

                this.$emit('fechado');
            }


        }
    }
</script>


<style scoped>
    .modal-dialog-centered {
        max-width: 65vw !important;
        width: 65vw !important;
    }

    .modal-plano {
        position: relative;
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f7f9fc 100%);
        box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14);
    }

    .modal-plano-close {
        position: absolute;
        top: 1.2rem;
        right: 1.2rem;
        width: 46px;
        height: 46px;
        border-radius: 50% !important;
        background: #ffffff;
        border: 1px solid rgba(226, 232, 240, 0.7) !important;
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 5;
    }

    .modal-plano-close:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 34px rgba(15, 23, 42, 0.25);
    }

    .modal-plano-body {
        padding: 2.2rem 2.5rem;
        border-radius: 20px;
    }

    @media (max-width: 768px) {
        .modal-plano-body {
            padding: 1.75rem;
        }
    }

    .modal-plano-inner {
        display: flex;
        flex-direction: column;
        gap: 1.75rem;
    }

    .modal-plano-header {
        display: flex;
        flex-direction: column;
        gap: 0.65rem;
    }

    .modal-plano-title {
        font-weight: 700;
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: -0.3px;
    }

    .modal-plano-title i {
        font-size: 1.5rem;
        background: inherit;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        filter: drop-shadow(0 5px 14px rgba(37, 99, 235, 0.28));
    }

    .modal-plano-subtitle {
        margin: 0;
        color: #475569;
        font-size: 0.96rem;
        max-width: 540px;
        line-height: 1.5;
    }

    .modal-plano-divider {
        border: 0;
        height: 2px;
        background: linear-gradient(90deg, rgba(37, 99, 235, 0), rgba(37, 99, 235, 0.4), rgba(37, 99, 235, 0));
        margin: 0;
    }

    .modal-plano-content {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .modal-plano .glass-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.98) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 18px;
        padding: 1.5rem;
        box-shadow: 0 12px 26px rgba(15, 23, 42, 0.1);
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
    }

    @media (max-width: 576px) {
        .modal-plano .glass-card {
            padding: 1.25rem;
        }
    }

    .modal-plano .form-group {
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        margin: 0;
    }

    .modal-plano .form-label {
        font-weight: 600;
        color: #1f2937;
        margin-bottom: -5px !important;
        margin-top: 9px !important;
    }

    .modal-plano .form-control {
        border-radius: 12px;
        border: 1px solid #d0d5dd;
        background: rgba(248, 250, 252, 0.85);
        box-shadow: none;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
    }

    .modal-plano textarea.form-control {
        resize: vertical;
        min-height: 140px;
    }

    .modal-plano .form-control:focus {
        background: #ffffff;
        border-color: #2563EB;
        box-shadow: 0 0 0 0.22rem rgba(37, 99, 235, 0.15);
    }

    .modal-plano .form-control::placeholder {
        color: #94a3b8;
    }

    .alert-plano {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1.25rem 1.5rem;
        border-radius: 16px;
        background: rgba(253, 224, 71, 0.14);
        border: 1px solid rgba(251, 191, 36, 0.45);
        color: #92400e;
        box-shadow: 0 10px 22px rgba(250, 204, 21, 0.18);
    }

    .alert-plano-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: rgba(251, 191, 36, 0.16);
        color: #d97706;
        font-size: 1.4rem;
    }

    .alert-plano strong {
        display: block;
        margin-bottom: 0.25rem;
    }

    .modal-plano .riscos-group {
        gap: 0.75rem;
    }

    .modal-plano .filtro-risco {
        padding-left: 2.5rem;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='1.5' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M21 21l-4.35-4.35m0 0A7.5 7.5 0 105.25 5.25a7.5 7.5 0 0011.4 11.4z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: 0.85rem center;
        background-size: 1.15rem;
    }

    .lista-riscos {
        max-height: 230px;
        overflow-y: auto;
        border: 1px solid rgba(226, 232, 240, 0.85);
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6);
    }

    .lista-riscos-item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.8rem 1rem;
        border-bottom: 1px solid rgba(226, 232, 240, 0.75);
        cursor: pointer;
        transition: background 0.2s ease;
    }

    .lista-riscos-item:last-child {
        border-bottom: none;
    }

    .lista-riscos-item:hover {
        background: rgba(37, 99, 235, 0.08);
    }

    .lista-riscos-item .form-check-input {
        width: 1.1rem;
        height: 1.1rem;
        border-radius: 4px;
        border: 1px solid #cbd5f5;
        cursor: pointer;
    }

    .lista-riscos-item .form-check-input:checked {
        background-color: #2563EB;
        border-color: #2563EB;
    }

    .lista-riscos-item .codigo {
        font-weight: 600;
        color: #1f2937;
        min-width: 70px;
    }

    .lista-riscos-item .titulo {
        color: #475569;
        flex: 1;
    }

    .lista-riscos-vazia {
        padding: 1rem;
        text-align: center;
        color: #64748b;
        font-size: 0.95rem;
    }

    .riscos-group.tem-erro .lista-riscos {
        border-color: #f87171;
        box-shadow: 0 0 0 0.22rem rgba(248, 113, 113, 0.18);
    }

    .btn-save {
        align-self: stretch;
        padding: 0.9rem 1rem;
        font-size: 1.05rem;
        font-weight: 600;
        border-radius: 14px;
        border: none;
        background: linear-gradient(135deg, #2563EB 0%, #1d4ed8 100%);
        box-shadow: 0 18px 32px rgba(37, 99, 235, 0.22);
        color: #ffffff;
        transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
    }

    .btn-save:hover {
        transform: translateY(-1px);
        filter: brightness(1.03);
        box-shadow: 0 22px 38px rgba(37, 99, 235, 0.28);
    }

    .modal-plano .form-check-input:focus {
        box-shadow: 0 0 0 0.18rem rgba(37, 99, 235, 0.2);
    }

    .lista-riscos::-webkit-scrollbar,
    .modal-plano-body::-webkit-scrollbar {
        width: 10px;
    }

    .lista-riscos::-webkit-scrollbar-track,
    .modal-plano-body::-webkit-scrollbar-track {
        background: rgba(241, 245, 249, 0.75);
        border-radius: 8px;
    }

    .lista-riscos::-webkit-scrollbar-thumb,
    .modal-plano-body::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        border-radius: 8px;
    }

    .lista-riscos::-webkit-scrollbar-thumb:hover,
    .modal-plano-body::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #16a34a 100%);
    }

    [data-bs-theme="dark"] .modal-plano {
        background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
        box-shadow: 0 22px 50px rgba(0, 0, 0, 0.45);
        border: 1px solid rgba(71, 85, 105, 0.5);
    }

    [data-bs-theme="dark"] .modal-plano-close {
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        color: #e2e8f0;
        border-color: rgba(71, 85, 105, 0.65) !important;
    }

    [data-bs-theme="dark"] .modal-plano-title {
        -webkit-text-fill-color: currentColor;
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .modal-plano-title i {
        color: #38bdf8;
        -webkit-text-fill-color: currentColor;
        background: none;
    }

    [data-bs-theme="dark"] .modal-plano-subtitle {
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modal-plano-divider {
        background: linear-gradient(90deg, rgba(59, 130, 246, 0), rgba(59, 130, 246, 0.55), rgba(59, 130, 246, 0));
    }

    [data-bs-theme="dark"] .modal-plano .glass-card {
        background: linear-gradient(135deg, rgba(31, 41, 55, 0.95) 0%, rgba(17, 24, 39, 0.95) 100%);
        border: 1px solid rgba(71, 85, 105, 0.55);
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.45);
    }

    [data-bs-theme="dark"] .modal-plano .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-plano .form-control {
        background: rgba(17, 24, 39, 0.85);
        border-color: rgba(71, 85, 105, 0.65);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-plano .form-control:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 0.22rem rgba(59, 130, 246, 0.22);
    }

    [data-bs-theme="dark"] .modal-plano .form-control::placeholder {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .alert-plano {
        background: rgba(124, 58, 237, 0.12);
        border-color: rgba(139, 92, 246, 0.45);
        color: #ede9fe;
    }

    [data-bs-theme="dark"] .alert-plano-icon {
        background: rgba(139, 92, 246, 0.18);
        color: #c4b5fd;
    }

    [data-bs-theme="dark"] .lista-riscos {
        background: rgba(15, 23, 42, 0.9);
        border-color: rgba(71, 85, 105, 0.55);
        box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.9);
    }

    [data-bs-theme="dark"] .lista-riscos-item {
        border-color: rgba(71, 85, 105, 0.5);
    }

    [data-bs-theme="dark"] .lista-riscos-item:hover {
        background: rgba(59, 130, 246, 0.18);
    }

    [data-bs-theme="dark"] .lista-riscos-item .codigo {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .lista-riscos-item .titulo {
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .lista-riscos-vazia {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .btn-save {
        box-shadow: 0 18px 38px rgba(37, 99, 235, 0.35);
    }

    .border-danger {
        border-color: #f87171 !important;
        box-shadow: 0 0 0 0.22rem rgba(248, 113, 113, 0.2) !important;
    }
</style>
